module.exports = __webpack_public_path__ + "static/media/soure-1.6255bea3.jpg";